<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableBackupRepository",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.backupVaultName"),
          key: "backupVaultName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path:
                        "/resourceConfigurationManagement/aws/backup/replicationInstances/backupVaultName",
                      query: {
                        backupVaultName: params.row.backupVaultName,
                        id: params.row.id,
                        type: "backupVaultName",
                        t: Date.now()
                      }
                    });
                  }
                }
              },
              params.row.backupVaultName
            );
          }
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.numberOfRecoveryPoints"),
          key: "numberOfRecoveryPoints"
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.encryptionKeyArn"),
          key: "encryptionKeyArn"
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.creationDate"),
          key: "creationDate"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("backupVaultName", function(val) {
      tableDataVue.backupVaultName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAwsBackupVaultByPage({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          backupVaultName: tableDataVue.backupVaultName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/repository/TableBackupRepository.vue